import React, {Component} from 'react';
import {ShareButtons, generateShareIcon} from 'react-share'

const {
    FacebookShareButton,
    GooglePlusShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    WhatsappShareButton
} = ShareButtons;

const FacebookIcon = generateShareIcon('facebook');
const TwitterIcon = generateShareIcon('twitter');
const WhatsappIcon = generateShareIcon('whatsapp');
const GooglePlusIcon = generateShareIcon('google');
const LinkedinIcon = generateShareIcon('linkedin');

const styleSheet = {
    share: {
        marginTop: 50,
        marginBottom: 100,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
    },
    pointer: {
        cursor: 'pointer',
        ':focus':'none',
    },
};

class SocialShare extends Component {

    render() {
        const round = true;
        const size = 32;
        return (
            <div style={styleSheet.share}>
                <FacebookShareButton style={styleSheet.pointer}
                                     url='https://www.facebook.com/sharer/sharer.php?u=http://www.naduvida.com.br&t=NaDúvida'>

                    <FacebookIcon size={size} round={round}/>
                </FacebookShareButton>

                <TwitterShareButton style={styleSheet.pointer}
                                    url="https://twitter.com/intent/tweet?text=fdfgsdf">

                    <TwitterIcon size={size} round={round}/>
                </TwitterShareButton>

                <WhatsappShareButton style={styleSheet.pointer}
                                     url="whatsapp://send?text={url}">

                    <WhatsappIcon size={size} round={round}/>
                </WhatsappShareButton>

                <GooglePlusShareButton style={styleSheet.pointer}
                                       url="http://plus.google.com/share?url=http://{{ host }}.{{ domain }}/{{ url }}">

                    <GooglePlusIcon size={size} round={round}/>
                </GooglePlusShareButton>

                <LinkedinShareButton style={styleSheet.pointer}
                                     url="https://www.linkedin.com/shareArticle?url={url}&title={title}">

                    <LinkedinIcon size={size} round={round}/>
                </LinkedinShareButton>

            </div>
        )
    }
}

export default SocialShare




// WEBPACK FOOTER //
// ./src/social-share.jsx